import HandleRequest from './../../handle_request';
import ApiService from './../../api_service';
import { formatGetKbInfo, formatUpdateKbInfo, formatKbud } from './format';
import { manual_kb as URL } from './../../urls';
import { obj } from './../../urls';
import { getPrivilege } from '../utils';
import Privilege from 'privilege_manager/privileges';
import { alert } from 'components/modals';

export const getItemTypes = (data, success, error) => {
  HandleRequest(
    () => ApiService.post(obj.getItemTypes, data),
    (resp) => success(resp.getItemTypes),
    (dataError) => error(dataError),
    { api: obj.getItemTypes, data }
  );
}

export const getKbInfo = (data, success, error) => {
  HandleRequest(
    () => ApiService.post(URL.getKbInfo, data),
    (resp) => success(formatGetKbInfo(resp.getKbInfo)),
    (dataError) => error(dataError),
    { api: URL.getKbInfo, data }
  )
}

/**
 * Description: only for "standard_kb" privilege
 * */
export const updateKbInfo = (data, success, error) => {
  getPrivilege(Privilege.standard_kb, (resp) => {
    if(resp.permit){
      _updateKbInfo(data, success, error, resp);
    }else{
      alert({
        title: 'Permiso denegado',
        body: `Lo sentimos, no tienes el permiso necesario 
          para ver editar los metadatos de esta base de conocimiento.`,
        btn_ok: 'salir'
      })
    }
  }, data.pid)
}

const _updateKbInfo = (data, success, error) => {
  HandleRequest(
    () => ApiService.post(URL.updateKbInfo, data),
    (resp) => success(formatUpdateKbInfo(resp.updateKbInfo)),
    (errorData) => error(errorData),
    { api: URL.updateKbInfo, data }
  )
}

export const saveKb = (data, success, error) => {
  HandleRequest(
    () => ApiService.post(URL.saveKb, data),
    (resp) => success(formatUpdateKbInfo(resp.saveKb)),
    (errorData) => error(errorData),
    { api: URL.saveKb, data }
  )
}

export const getKbPreview = (data, success, error) => {
  HandleRequest(
    () => ApiService.post(URL.kbPreview, data),
    (resp) => success(resp.getKbPreview.data),
    (errorData) => error(errorData),
    { api: URL.getKbPreview, data }
  )
}

/**
 * Arbol completo de una BC, como lista plana de items. Hidrata la pantalla de
 * redaccion al abrir una BC ya guardada.
 *
 * El servidor elige solo de que tabla lee segun el estado, y no devuelve ni el
 * item raiz ni los dados de baja.
 */
export const getKbItems = (data, success, error) => {
  return HandleRequest(
    () => ApiService.post(URL.getKbItems, data),
    (resp) => {
      if(!success) return;
      success({ ...resp.getKbItems, last_updated: formatKbud(resp.getKbItems.kbud) });
    },
    (e_data) => { if(error) error(e_data) },
    { api: URL.getKbItems, data }
  )
}

/**
 * Unico escritor del arbol en el flujo manual. Aplica altas, modificaciones y
 * bajas en una transaccion y en ese orden.
 *
 * Maximo 500 filas por peticion entre las tres colecciones. Cada lote se aplica
 * al llegar: no hay confirmacion diferida ni numero de secuencia, asi que un
 * `tmp` solo se resuelve dentro de su propio lote y entre lotes hay que usar el
 * iid real que devolvio el idmap del anterior.
 */
export const saveKbItems = (data, success, error) => {
  return HandleRequest(
    () => ApiService.post(URL.saveKbItems, data),
    (resp) => {
      if(!success) return;
      success({ ...resp.saveKbItems, last_updated: formatKbud(resp.saveKbItems.kbud) });
    },
    (e_data) => { if(error) error(e_data) },
    { api: URL.saveKbItems, data }
  )
}

